import { useState } from "react";
import { Box, Select } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { getSelectOptionsByTableName } from "../../../services/common.service";

const SelectWithCleared = ({
  placeholder,
  label,
  value,
  itemData,
  setValue,
  isRequired,
  tableName,
  error,
  isCockpit,
  ...props
}) => {
  const [search, setSearch] = useState("");

  const getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
  };
  const getSearchValue = (searchText) => {
    if (!searchText) return "";
    const parts = searchText.split(" - ");
    return parts[parts.length - 1]; 
  };
  const { data: options } = useQuery({
    queryKey: ["select-options", tableName, search, itemData?.filters],
    queryFn: () =>
      getSelectOptionsByTableName({
        tableName,
        filters: itemData?.filters || '{"is_active_eq":true}',
        page: -1,
        search: getSearchValue(search),
      }),
    select: (data) =>
      data?.map((item) => {
        const displayOptions = JSON.parse(itemData?.display_options || "[]");
        const labelText = displayOptions
          .map((opt) => getNestedValue(item, opt))
          .filter(Boolean)
          .join(" - ");
        let val;
        if (isCockpit) {
          val = getNestedValue(item, itemData?.return_value);
        } else {
          val = Array.isArray(itemData?.return_value)
            ? itemData.return_value
                .map((k) => getNestedValue(item, k))
                .join(" - ")
            : getNestedValue(item, itemData?.return_value);
        }

        return { ...item, label: labelText, value: val?.toString() };
      }),
    staleTime: 0,
    cacheTime: 0,
  });

  const handleChange = (val) => {
    if (!val) return setValue(null, null);
    const selectedOption = options?.find((o) => o.value === val);
    setValue(val, selectedOption);
  };

  return (
    <Box>
      <Select
        data={options || []}
        placeholder={placeholder}
        value={value || null}
        onChange={handleChange}
        searchable
        clearable
        searchValue={search}
        onSearchChange={setSearch}
        label={label}
        error={error}
        withAsterisk={isRequired}
        {...props}
      />
    </Box>
  );
};

export default SelectWithCleared;
